module.exports = __webpack_public_path__ + "img/sneaker-create.b7420196.png";